import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";

function About() {
  return (
    <div className="about">
      <Header />

      <main>
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-image-container">
            <img
              src="/main/a1.jpeg"
              alt="Setting a New Standard in Pet Care"
              className="hero-bg"
            />
            <div className="hero-overlay">
              <h1>Setting a New Standard in Pet Care</h1>
            </div>
          </div>
        </section>

        {/* Intro Section */}
        <section className="about-intro">
          <div className="intro-container">
            <div className="intro-image">
              <img src="/main/a2.jpeg" alt="Pet Store Aisle" />
            </div>
            <div className="intro-content">
              <h2>A Different Kind of Pet Store</h2>
              <p>
                hetcratehub is built around useful choices and straightforward
                guidance for everyday pet care.
              </p>
              <p>
                We want shopping for a companion to feel calm and considered.
                That means keeping product information readable and making help
                easy to reach when a question comes up.
              </p>
              <p>
                Our range is organised around common needs, from everyday meals
                and rewards to simple care essentials. We keep learning from pet
                families so the store can become more useful over time.
              </p>
            </div>
          </div>
        </section>

        {/* What Guides Us Section */}
        <section className="what-guides-us">
          <div className="section-header">
            <h2>WHAT GUIDES US</h2>
          </div>

          <div className="guides-grid">
            <div className="guide-card">
              <img src="/main/a3-1.jpeg" alt="Knowledge" />
              <h3>KNOWLEDGE</h3>
              <p>
                Pet care comes with questions. We present practical information
                in plain language so choices are easier to compare.
              </p>
            </div>

            <div className="guide-card">
              <img src="/main/a3-2.jpeg" alt="Experience" />
              <h3>EXPERIENCE</h3>
              <p>
                Every detail should support the day-to-day moments people share
                with their animals, from mealtime to playtime.
              </p>
            </div>

            <div className="guide-card">
              <img src="/main/a3-3.jpeg" alt="Individuality" />
              <h3>INDIVIDUALITY</h3>
              <p>
                No two companions have exactly the same routine. Our selection
                reflects different ages, tastes, sizes, and household needs.
              </p>
            </div>

            <div className="guide-card">
              <img src="/main/a3-4.jpeg" alt="Trust" />
              <h3>TRUST</h3>
              <p>
                Clear details, consistent service, and honest communication are
                the foundation of a dependable shopping experience.
              </p>
            </div>

            <div className="guide-card">
              <img src="/main/a3-5.jpeg" alt="Community" />
              <h3>COMMUNITY</h3>
              <p>
                We listen to the people who share their lives with animals and
                use that feedback to improve how we select and explain products.
              </p>
            </div>
          </div>
        </section>

        {/* Our Team Section */}
        <section className="our-team">
          <div className="team-container">
            <div className="team-content">
              <h2>Our Team</h2>
              <p>
                Your pets matter to you, and every choice we make starts there.
                hetcratehub is supported by people who understand the care that
                goes into choosing food, treats, and everyday essentials.
              </p>
              <p>
                We combine hands-on pet experience with careful product review,
                while encouraging customers to seek qualified veterinary advice
                whenever a health question needs professional attention.
              </p>
            </div>
            <div className="team-image">
              <img src="/main/a4.jpeg" alt="Our Team Member with Dog" />
            </div>
          </div>
        </section>

        {/* Our Community Section */}
        <section className="our-community">
          <div className="community-header">
            <h2>OUR COMMUNITY</h2>
            <p>
              Strong pet communities are built by people who share knowledge,
              offer practical support, and help animals find safe homes. We value
              those efforts and aim to be a thoughtful participant wherever our
              customers and their companions live.
            </p>
          </div>

          <div className="community-images">
            <img src="/main/a5-1.jpeg" alt="Community Partner 1" />
            <img src="/main/a5-5.jpeg" alt="Community Partner 2" />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
